import React from "react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBjb250cmFjdG9yJTIwd29ya2luZyUyMGJsdWVwcmludHxlbnwwfHx8fDE3Nzg2NTcyMjN8MA&ixlib=rb-4.1.0&q=85";

const FITS = [
  "Small to mid-sized businesses",
  "Startups and scaling companies",
  "Contractors and trades businesses",
  "Consultants, medical offices and service-based firms",
  "Real estate professionals and property managers",
  "Retail and e-commerce businesses",
  "Incorporated professionals",
  "Non-profits and community organizations",
];

export default function About() {
  return (
    <section
      id="about"
      className="section-anchor py-24 md:py-32 bg-cream"
      data-testid="about-section"
    >
      <div className="px-6 md:px-12 lg:px-20 max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5 relative order-2 lg:order-1">
            <img
              src={ABOUT_IMG}
              data-testid="about-image"
              alt="Architect/contractor planning project — DSO Books target client"
              className="w-full aspect-[4/5] object-cover"
              loading="lazy"
            />
            <div className="absolute -bottom-6 -left-6 bg-navy text-cream p-6 max-w-[260px] hidden md:block">
              <div className="font-serif text-3xl">Ontario, CA</div>
              <div className="mt-2 text-xs uppercase tracking-[0.2em] text-cream/70">
                Serving Canadian businesses, virtually nationwide.
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="uppercase text-xs tracking-[0.25em] font-bold text-gold mb-4">
              About DSO Books Solutions Inc.
            </div>
            <h2 className="font-serif text-4xl md:text-5xl text-navy tracking-tight leading-[1.05]">
              A finance partner built for Canadian operators who&rsquo;ve
              <span className="italic"> outgrown spreadsheets.</span>
            </h2>
            <p className="mt-6 text-stone text-base md:text-lg leading-relaxed">
              We deliver high-accuracy, CRA-compliant bookkeeping that combines precision,
              speed, and proactive financial insight. Our service model is built around
              one principle: your books should never be the reason a decision gets
              delayed.
            </p>
            <p className="mt-4 text-stone text-base md:text-lg leading-relaxed">
              We position ourselves as a trusted financial operations partner — not just a
              bookkeeper. That means clean financials, on-time filings, and the kind of
              cash flow visibility that helps you grow with confidence.
            </p>

            <div className="mt-10">
              <div className="uppercase text-xs tracking-[0.2em] font-semibold text-navy mb-4">
                Who we work best with
              </div>
              <p className="text-stone text-base md:text-lg leading-relaxed mb-6">
                Our clients are growth-focused businesses and professionals who value
                accurate financials, reliable reporting, and proactive support — without
                the overhead of an accounting department.
              </p>
              <ul className="grid sm:grid-cols-2 gap-3">
                {FITS.map((f, i) => (
                  <li
                    key={i}
                    data-testid={`about-fit-${i}`}
                    className="flex items-start gap-3 text-[15px] text-ink/85"
                  >
                    <span className="mt-2 w-1.5 h-1.5 bg-gold shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
